import React, { useEffect, useState } from "react";
import { Spinner, Table } from "reactstrap";
import DatePicker from "react-flatpickr";
import FooterPagination from "../../Pagination/FooterPagination";
import { formatDate } from "../../../utils/utils";
import { updateClientEligibilityByMemberId } from "../../../slices/admin/thunk";
import { useDispatch } from "react-redux";

const CETable = ({ setData, data, paginationProps }) => {
  const dispatch = useDispatch();
  const [editingField, setEditingField] = useState(null);
  const [editedValues, setEditedValues] = useState({});
  const [loadingStartDateIndex, setLoadingStartDateIndex] = useState(null);
  const [loadingEndDateIndex, setLoadingEndDateIndex] = useState(null);

  const handleEditChange = async (
    selectedDates,
    dateStr,
    index,
    field,
    memberId
  ) => {
    const newEditedValues = { ...editedValues };
    newEditedValues[`${index}-${field}`] = dateStr;
    setEditedValues(newEditedValues);

    if (field === "startDate") {
      setLoadingStartDateIndex(index);
    } else if (field === "endDate") {
      setLoadingEndDateIndex(index);
    }

    try {
      const response = await dispatch(
        updateClientEligibilityByMemberId({
          memberId: memberId,
          data: { [field]: dateStr },
        })
      );

      if (response) {
        setData((prevData) => {
          const newData = [...prevData];
          newData[index] = { ...newData[index], [field]: dateStr };
          return newData;
        });
      }
    } catch (error) {
      console.error("Error editing values:", error);
    }

    if (field === "startDate") {
      setLoadingStartDateIndex(null);
    } else if (field === "endDate") {
      setLoadingEndDateIndex(null);
    }
    setEditingField(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (editingField && !event.target.closest(".flatpickr-calendar")) {
        setEditingField(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [editingField]);

  return (
    <Table className="table table-hover border table-centered align-middle table-nowrap mb-0">
      <thead className="bg" style={{ background: "var(--thead-bg)" }}>
        <tr>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Email</th>
          <th>Phone Number</th>
          <th>Full Address</th>
          <th>Member ID</th>
          <th>Start Date</th>
          <th>End Date</th>
        </tr>
      </thead>
      <tbody>
        {!data?.length && (
          <tr>
            <td className="text-center" colSpan="8">
              No data available
            </td>
          </tr>
        )}
        {data.map((user, index) => {
          const { memberId, startDate, endDate } = user;
          return (
            <tr key={`${memberId}-${index}`}>
              <td>{user.firstName}</td>
              <td>{user.lastName}</td>
              <td>{user.email}</td>
              <td>{user.phone}</td>
              <td>{user.fullAddress}</td>
              <td>{user.memberId}</td>
              <td>
                {loadingStartDateIndex === index ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner size="sm" color="primary" />
                  </div>
                ) : (
                  <DatePicker
                    value={
                      editedValues[`${index}-startDate`] ||
                      formatDate(startDate)
                    }
                    onChange={(selectedDates, dateStr) =>
                      handleEditChange(
                        selectedDates,
                        dateStr,
                        index,
                        "startDate",
                        memberId
                      )
                    }
                    options={{ dateFormat: "m-d-Y" }}
                    className="border cursor-pointer border-primary text-center rounded w-100"
                  />
                )}
              </td>
              <td>
                {loadingEndDateIndex === index ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner size="sm" color="primary" />
                  </div>
                ) : (
                  <DatePicker
                    value={
                      editedValues[`${index}-endDate`] || formatDate(endDate)
                    }
                    onChange={(selectedDates, dateStr) =>
                      handleEditChange(
                        selectedDates,
                        dateStr,
                        index,
                        "endDate",
                        memberId
                      )
                    }
                    options={{ dateFormat: "m-d-Y" }}
                    className="border cursor-pointer border-primary text-center rounded w-100"
                  />
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
      {paginationProps?.totalItems > 1 && (
        <tfoot>
          <FooterPagination {...paginationProps} />
        </tfoot>
      )}
    </Table>
  );
};

export default CETable;
